export default __webpack_public_path__ + "static/media/playStore.3e1614e8.svg";